import * as React from "react";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
const ScriptNotificationDetails = ({ notification }) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("script_notifications.script_path"), value: (_a = notification.config) == null ? void 0 : _a.script_path }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("script_notifications.script_arguments"), value: (_b = notification.config) == null ? void 0 : _b.script_args }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("script_notifications.send_stdin"), value: (_c = notification.config) == null ? void 0 : _c.script_send_stdin }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: t("script_notifications.script_timeout_milliseconds"),
      value: (_d = notification.config) == null ? void 0 : _d.script_timeout
    }
  ));
};
export default ScriptNotificationDetails;
